<template>
    <div class="flex items-center justify-between pb-6">
        <div>
            <div class="font-semibold text-base">
                {{ addOn.label }}
                <span v-if="isPayAtLocation">*</span>
            </div>

            <span class="text-sm text-gray-600">
                {{ $n(addOn.price, 'currency') }}
            </span>

            <AddOnChildren :children="addOn.children" />
        </div>

        <Button @click="toggle" :class="checked ? 'btn-secondary' : 'btn-primary'" size="sm">
            <i v-if="checked" class="icon-close-light mr-1"></i>
            {{ checked ? $t('Remove') : $t('Add') }}
        </Button>
    </div>
</template>

<script setup>
import AddOnChildren from './AddOnChildren.vue'

const props = defineProps({
    addOn: { type: Object, required: true },
    value: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    onChange: {
        type: Function,
        required: false
    }
})

const checked = computed(() => props.value)
const isPayAtLocation = computed(() => props.addOn?.payAtLocation || props.addOn?.pay_at_location)

const toggle = () => {
    props.onChange?.(!checked.value)
}
</script>
